module.exports = __webpack_public_path__ + "img/WP2023-Icon-Posters.9034d5a6.svg";